/**
 * Sérialisation déterministe d'un jeu de feature flags, pour détecter un
 * changement entre deux fetchs de `/api/feature-flags/me` (cf. AppUpdatePrompt).
 *
 * Les clés sont triées et les valeurs normalisées en booléen strict : deux jeux
 * de flags équivalents produisent toujours la même chaîne, quel que soit
 * l'ordre de retour de l'API. Un flag absent et un flag `false` sont considérés
 * comme équivalents (le backend ne renvoie que les rows existantes : une agence
 * jamais togglée n'a pas de row, une agence désactivée a une row à false).
 */
export const serializeFlagsSnapshot = (flags: Partial<Record<string, boolean>>): string => {
  const enabledEntries = Object.entries(flags)
    .filter(([, enabled]) => Boolean(enabled))
    .map(([key]) => key)
    .sort();
  return JSON.stringify(enabledEntries);
};
